import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export const Tooltip = styled.div`
  width: 100%;
  & {
    position: relative;
    width: 100%;
  }
  display: inline-block;
`;
export const TooltipOverlay = styled.div``;

export const TooltipWrapper = styled.div`
  display: block;
  position: relative;
  ${({ position }) => getPositionWrapper(position)}
`;

export const TooltipArrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;

  ${({ position }) => getArrow(position)};
  ${({ position }) => getPositionArrow(position)};
`;

export const TooltipMessage = styled.div`
  pointer-events: none;
  will-change: transform;
  width: max-content;
  width: -moz-max-content;
  white-space: pre-wrap;
  border-radius: ${theme.borderRadius['border-radius-3']};
  padding: ${theme.spacing['spacing-1']} ${theme.spacing['spacing-3']};
  background-color: black;
  color: ${theme.colors.neutral.text.inverted};
`;

export const ChildrenWrapper = styled.div`
  width: auto !important;
`;

const getPositionArrow = (position) => {
  switch (position) {
    case 'top':
      return css`
        border-width: 6px 6px 0 6px;
        border-color: black transparent transparent transparent;
        bottom: 0;
        left: calc(50% - 6px);
      `;
    case 'top-right':
      return css`
        border-width: 6px 6px 0 6px;
        border-color: black transparent transparent transparent;
        bottom: 0;
        right: calc(0% + 8px);
      `;
    case 'top-left':
      return css`
        border-width: 6px 6px 0 6px;
        border-color: black transparent transparent transparent;
        bottom: 0;
        left: calc(0% + 8px);
      `;
    case 'bottom':
      return css`
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent black transparent;
        top: 0;
        left: calc(50% - 6px);
      `;
    case 'bottom-left':
      return css`
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent black transparent;
        left: calc(0% + 8px);
        top: 0;
      `;
    case 'bottom-right':
      return css`
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent black transparent;
        right: calc(0% + 8px);
        top: 0;
      `;
    case 'right':
      return css`
        border-width: 6px 6px 6px 0;
        border-color: transparent black transparent transparent;
        left: 0;
        top: calc(50% - 6px);
      `;
    case 'left':
      return css`
        border-width: 6px 0 6px 6px;
        border-color: transparent transparent transparent black;
        right: 0;
        top: calc(50% - 6px);
      `;
    default:
      return css``;
  }
};

const getPositionWrapper = (position) => {
  switch (position) {
    case 'top':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-1']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']};
      `;
    case 'top-left':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']};
      `;
    case 'top-right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-2']};
      `;
    case 'bottom':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;

    case 'bottom-left':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
    case 'bottom-right':
      return css`
        padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
    case 'right':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-1']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-2']};
      `;
    case 'left':
      return css`
        padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-3']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
        margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-2']}
          ${theme.spacing['spacing-0']} ${theme.spacing['spacing-0']};
      `;
  }
};

const getArrow = (position) => {
  let aux = position.indexOf('-');
  let positions;
  aux == -1 ? (positions = position) : (positions = position.slice(0, aux));
  return css`
    border-color: transparent;
    border-${positions}-color: black`;
};
